import Link from '@code-dot-org/component-library/link';
import {Typography} from '@mui/material';
import React from 'react';

import analyticsReporter from '@cdo/apps/metrics/AnalyticsReporter';
import i18n from '@cdo/locale';

import {LmsInformationalCardProps} from './types';

import styles from './lmsInformationalCard.module.scss';

const LmsInformationalCard = ({
  lmsName,
  lmsInformationalUrl,
  lmsLogo,
}: LmsInformationalCardProps) => {
  const publishClickEvent = () => {
    analyticsReporter.sendEvent('section_create_lms_tile_click', {
      lms_name: lmsName,
    });
  };

  return (
    <div className={styles.card}>
      <div className={styles.cardText}>
        <Typography className={styles.title} variant="h4" gutterBottom>
          {lmsName}
        </Typography>
        <Link
          text={i18n.addStudentsToSectionViewSetupGuide()}
          href={lmsInformationalUrl}
          onClick={publishClickEvent}
          size={'xs'}
          openInNewTab={true}
          className={styles.lmsInstructionsLink}
        />
      </div>
      <img src={lmsLogo} alt={lmsName} className={styles.logo} />
    </div>
  );
};

export default LmsInformationalCard;
